import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";

// useNextStep reads the product's next step (0051 slice 2): GET
// /api/v1/products/{pid}/next-step, which decodes no tree. Its key sits under
// "products" (["products", pid, "next-step"]), so every invalidation of the
// products list - a save, an act, a pass's end - refreshes it, and it refetches
// on window focus (the default).
export function useNextStep(productId: string) {
  return useQuery({
    queryKey: ["products", productId, "next-step"],
    queryFn: async () => {
      const { data, error, response } = await apiClient.GET("/api/v1/products/{pid}/next-step", {
        params: { path: { pid: productId } },
      });
      // The status rides the thrown error, so the app's retry rule reads it.
      if (error) throw Object.assign(new Error("next-step"), { status: response.status });
      return data;
    },
    enabled: !!productId,
  });
}
